// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Upgu","left":"styles_left__2qyzs","desktopActions":"styles_desktopActions__3bvUI","title":"styles_title__qoO92"};